import { forwardRef, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import InputContent from "../Components/InputContent";
import { ReactComponent as IconImageHover } from "../Images/icon_image_hover.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import Layout from "../Layout/Layout";
import LayoutModal from "../Layout/LayoutModal";
import AlarmApply from "../Modals/AlarmApply";
import AlarmCancel from "../Modals/AlarmCancel";
import AlarmInputCheck from "../Modals/AlarmInputCheck";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const QnAApplyContent = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [nation, setNation] = useState("");
  const [nickName, setNickName] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");
  const [reply, setReply] = useState("");
  const [status, setStatus] = useState(null);

  const [clickApply, setClickApply] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const [clickImage, setClickImage] = useState(false);
  const [inputCheckFail, setInputCheckFail] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const previewRef = useRef(null);
  const lastQnADetailRequestKey = useRef(null);

  const handleClickX = () => {
    setClickApply(false);
    setClickCancel(false);
    setInputCheckFail(false);
  };

  const getQnAData = async () => {
    try {
      const body = { qnaId: id };
      const res = await postJson("/dashboard/qna/getDetail", body, navigate);
      console.log(res);
      if (res.code === 200) {
        const data = res.data;
        setNation(
          data.cCode === "kr"
            ? "대한민국"
            : data.cCode === "cn"
            ? "중국"
            : data.cCode === "us"
            ? "미국"
            : data.cCode === "jp"
            ? "일본"
            : data.cCode === "tw"
            ? "대만"
            : ""
        );
        setNickName(data.nickName);
        setEmail(data.email);
        setImage(data.image);
        setContent(data.content);
        setStatus(data.status);
      }
    } catch (error) {
      console.log("문의 정보 가져오기 중 에러");
      throw error;
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ id });

    if (lastQnADetailRequestKey.current === requestKey) {
      return;
    }

    lastQnADetailRequestKey.current = requestKey;
    getQnAData();
  }, [id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setClickImage(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleApplyQnA = async () => {
    if (!reply) {
      setInputCheckFail(true);
    } else {
      try {
        const body = { qnaId: id, reply };
        const res = await postJson("/dashboard/qna/update", body, navigate);

        if (res.code === 200) {
          navigate("/qna", { state: { toast_enable: true } });
        }
      } catch (error) {
        console.log("문의 답변 등록 중 에러");
        throw error;
      }
    }
  };

  return (
    <div>
      {clickApply && (
        <AlarmApply
          title="문의 답변을 등록하시겠습니까?"
          subtitle="등록 시 유저의 이메일로 답변 내용이 발송됩니다."
          handleApply={handleApplyQnA}
          handleClickX={handleClickX}
        />
      )}
      {clickCancel && (
        <AlarmCancel
          title="작성하던 내용을 취소하시겠습니까?"
          subtitle="작성하던 내용은 저장되지 않습니다."
          handleCancel={() => navigate("/qna")}
          handleClickX={handleClickX}
        />
      )}
      {inputCheckFail && <AlarmInputCheck handleClickX={handleClickX} />}
      {clickImage && image && <PreviewImage image={image} ref={previewRef} />}
      <QnAApplyBox>
        <div className="title-in-box">문의 답변 등록</div>
        <div className="hrz-wrapper">
          <div
            className="text-for-notice"
            style={{ marginLeft: "auto", marginTop: "10px" }}
          >
            *표시는 필수 입력 항목입니다.
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div>
            <div
              className="hrz-wrapper subtitle-in-box"
              style={{ marginTop: "14px", fontFamily: "notoSans-medium" }}
            >
              발송 여부
            </div>
            <div
              className="contentBox"
              style={{ width: "320.5px", backgroundColor: "#e4e4e4" }}
            >
              {status === 0 ? "미발송" : "발송완료"}
            </div>
          </div>
          <div style={{ marginLeft: "14px" }}>
            <div
              className="hrz-wrapper subtitle-in-box"
              style={{ marginTop: "14px", fontFamily: "notoSans-medium" }}
            >
              국가
            </div>
            <div className="contentBox" style={{ width: "320.5px" }}>
              {nation}
            </div>
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div>
            <div
              className="hrz-wrapper subtitle-in-box"
              style={{ marginTop: "14px", fontFamily: "notoSans-medium" }}
            >
              닉네임
            </div>
            <div className="contentBox" style={{ width: "320.5px" }}>
              {nickName}
              ----------------------------------------------------------------------------------
            </div>
          </div>
          <div style={{ marginLeft: "14px" }}>
            <div
              className="hrz-wrapper subtitle-in-box"
              style={{ marginTop: "14px", fontFamily: "notoSans-medium" }}
            >
              이메일
            </div>
            <div className="contentBox" style={{ width: "320.5px" }}>
              {email}
            </div>
          </div>
        </div>

        <div
          className="hrz-wrapper subtitle-in-box"
          style={{ marginTop: "14px", fontFamily: "notoSans-medium" }}
        >
          문의내용
        </div>
        <div
          className="addImageButton"
          style={{ marginTop: "8px", marginBottom: "20px" }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isHovered && (
            <ImageHoveredDiv onClick={() => setClickImage(true)}>
              <IconImageHover />
            </ImageHoveredDiv>
          )}
          {image ? (
            <img
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "inherit",
                cursor: "pointer",
              }}
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${image}`}
            />
          ) : (
            <div />
          )}
        </div>

        <div
          className="contentBox"
          style={{
            width: "695px",
            height: "auto",
            boxShadow: "none",
            display: "block",
          }}
        >
          {content}
        </div>

        <hr
          color="#e4e4e4"
          style={{
            marginTop: "20px",
            marginBottom: "20px",
            border: 0,
            height: "1px",
          }}
        />

        <div
          className="hrz-wrapper subtitle-in-box"
          style={{ fontFamily: "notoSans-medium" }}
        >
          답변*
        </div>

        <InputContent
          setContent={setReply}
          content={reply}
          placeholder="답변을 입력해주세요"
        />

        <div className="hrz-wrapper" style={{ marginTop: "8px" }}>
          <IconInfo width="20px" fill="#888888" />
          <div
            className="text-for-notice"
            style={{ fontSize: "15px", marginLeft: "4px" }}
          >
            등록한 답변은 해당 유저의 메일로 발송되며, 수정 후 재등록시 재발송
            됩니다.
          </div>
        </div>

        <div style={{ display: "flex", marginTop: "30px" }}>
          <div
            className="cancelBtn center"
            style={{ marginLeft: "auto" }}
            onClick={() => setClickCancel(true)}
          >
            취소
          </div>
          <div
            className="applyBtn center"
            style={{ marginLeft: "16px" }}
            onClick={() => setClickApply(true)}
          >
            등록
          </div>
        </div>
      </QnAApplyBox>
    </div>
  );
};

const PreviewImage = forwardRef(({ image }, ref) => {
  return (
    <LayoutModal
      Modal={
        <div ref={ref} style={{ maxWidth: "400px", height: "auto" }}>
          <img
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${image}`}
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      }
    />
  );
});

const QnAApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
`;

const ImageHoveredDiv = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: inherit;
  cursor: pointer;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const QnAApply = () => {
  return <Layout page={<QnAApplyContent />} />;
};

export default QnAApply;
